export const medicalProcedureFrag = `
    code
    description
    duration
`;
